import { h } from 'preact';

const MenuItem = ({text, href}) => (
  <a class="menu-item" href={href} target="_blank" rel="noreferrer">
    {text}
  </a>
);

export default MenuItem;
